export enum LoaderSectionIDsEnum {
  MainComponentVehicleReservationSearch="MainComponentVehicleReservationSearch" ,
  MainComponentVehicleReservationSearchByAgency="MainComponentVehicleReservationSearchByAgency",
  HomePageComponent="HomePageComponent",

}
